import { Release } from "@/CodegenTypes";
import { TT_DAY_MAPPING } from "@/constants";

export const getTtValidDayOptions = (releases: Release[]) => {
  const daysInReleases = releases
    .filter((r) => !r.isOver)
    .map((r) => {
      const day = r.releaseDay;
      // if (day === 0) {
      //   return 7;
      // }
      if (day === 5) {
        return 4;
      }
      return day;
    });
  const relevantSelections = Object.entries(TT_DAY_MAPPING)
    .map(([key, value]) => {
      // check if value has something daysInReleases does not
      const hasUnincludedDay = value.filter((d) => !daysInReleases.includes(d));
      if (!hasUnincludedDay.length) {
        return +key;
      }
    })
    .filter((selection): selection is number => selection !== undefined);
  return relevantSelections;
};
